export const extCategories = [
    { key: "plugin", val: "Frontend plugins" },
    { key: "module", val: "Backend modules" },
    { key: "misc", val: "Miscellaneous" },
    { key: "be", val: "Backend" },
    { key: "fe", val: "Frontend" },
    { key: "services", val: "Services" },
    { key: "templates", val: "Templates" },
    { key: "distribution", val: "Distribution" },
    { key: "example", val: "Examples" },
    { key: "doc", val: "Documentation" },
];

export const extStates = [
    { key: "alpha", val: "Alpha" },
    { key: "beta", val: "Beta" },
    { key: "stable", val: "Stable" },
    { key: "experimental", val: "Experimental" },
    { key: "test", val: "Test" },
];
export const pluginTypes: any = [
    { id: "list", val: "List" },
    { id: "detail", val: "Detail" },
    { id: "filter", val: "Filter" },
    { id: "filterresult", val: "Filter Result" },
    { id: "form", val: "Form" },
];

export const checkRenderType: any = [
    { id: "default", val: "Default checkbox" },
    { id: "checkboxToggle", val: "Toggle checkbox" },
    { id: "checkboxLabeledToggle", val: "Labeled toggle checkbox" },
];

export const dateFormats: any = [
    { id: "date", val: "Date" },
    { id: "datetime", val: "Datetime" },
    { id: "time", val: "Time" },
    { id: "timesec", val: "Timesec" },
];

export const defaultNumberformat: string = "integer";
export const defaultDateformat: string = "date";
export const defaultSelectType: string = "selectSingle";
export const defaultCheckRenderType: string = "default";

export const numberFormats: any = [
    { id: "integer", val: "Integer" },
    { id: "decimal", val: "Decimal" },
];

export const selectRenderType: any = [
    { id: "selectSingle", val: "Single Select" },
    { id: "selectSingleBox", val: "Single Select Box" },
    { id: "selectCheckBox", val: "Select Check Box" },
    { id: "selectMultipleSideBySide", val: "Select Multiple Side by Side" },
];

export const tableFields: any = [
    { id: "string", val: "String" },
    { id: "text", val: "Text" },
    { id: "richtext", val: "Rich Text" },
    { id: "email", val: "Email" },
    { id: "link", val: "Link" },
    { id: "number", val: "Number" },
    { id: "slug", val: "Slug" },
    { id: "color", val: "Color" },
    { id: "password", val: "Password" },
    { id: "date", val: "Date" },
    { id: "select", val: "Select" },
    { id: "image", val: "Image" },
    { id: "file", val: "File" },
    { id: "category", val: "Category" },
    { id: "check", val: "CheckBox" },
    { id: "radio", val: "Radio" },
    { id: "inline", val: "Child" },
    { id: "celement", val: "Content Elements" },
    { id: "form", val: "Form", seprator: true },
];

export const moduleFields: any = [
    { id: "string", val: "String" },
    { id: "text", val: "Text" },
    { id: "richtext", val: "Rich Text" },
    { id: "email", val: "Email" },
    { id: "link", val: "Link" },
    { id: "number", val: "Number" },
    { id: "slug", val: "Slug" },
    { id: "date", val: "Date" },
    { id: "select", val: "Select" },
    { id: "check", val: "CheckBox" },
    { id: "radio", val: "Radio" }
];

export const DefaultIcon: string = "828/Asset-16@4x.png";

export const typo3versions = [
    { key: "12", val: "Typo3 12" },
    { key: "13", val: "Typo3 13" },
    { key: "14", val: "Typo3 14" },
];